import SolanaProvider from './SolanaProvider'

export default SolanaProvider
